module.exports = __webpack_public_path__ + "img/antique-mirror-frame.41644c8a.png";